import { render, staticRenderFns } from "./CategoriaForm.vue?vue&type=template&id=f415b6fc&"
import script from "./CategoriaForm.vue?vue&type=script&lang=js&"
export * from "./CategoriaForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports